import { inject } from 'vue';
import { injectionSymbols } from '../config';
import type { ModalBottomSheetController } from './modal-bottom-sheet-controller';

const createInjectionError = (injectionName: string) =>
  new Error(`ERR_INJECTION_NOT_FOUND: ${injectionName}`);

export const useModal = () => {
  const modalController = inject<ModalBottomSheetController>(
    injectionSymbols.MODAL_CONTROLLER_SYMBOL,
  );
  if (modalController) {
    return modalController;
  }
  const error = createInjectionError(injectionSymbols.MODAL_CONTROLLER_SYMBOL);
  throw error;
};

export const useBottomSheet = () => {
  const bottomSheetController = inject<ModalBottomSheetController>(
    injectionSymbols.BOTTOM_SHEET_CONTROLLER_SYMBOL,
  );
  if (bottomSheetController) {
    return bottomSheetController;
  }
  const error = createInjectionError(
    injectionSymbols.BOTTOM_SHEET_CONTROLLER_SYMBOL,
  );
  throw error;
};
